
import Login from './pages/Login';
import DashBoard from './pages/DashBoard';
import { useMemo } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import CmiAccounting from './pages/CmiAccounting';
import AddProductWebsite from './pages/AddProductWebsite';
import ListofProducts from './pages/ListofProducts';
import PrivateRoute from './components/PrivateRoute';
import OrdersGlovo from './pages/OrdersGlovo';
import CarrefourOrdersToday from './pages/CarrefourOrdersToday';
import MapComponent from './pages/MapComponent';
import StockByStore from './pages/StockByStore';
import StockUserHandle from './pages/StockUserHandle';
import CarrefourEcommerce from './pages/CarrefourEcommerce';
import StoreQuickProduct from './pages/StoreQuickProduct';
import StoreExpress from './pages/StoreExpress';
import DeliveriesApp from './pages/DeliveriesApp';
import OrdersForCarrefourPage from './ordersForCarrefour/OrdersForCarrefourPage';

import BarcodePage from './pages/BarcodePage';
import GlovoNotes from './pages/glovo/glovoNotes';
import GlovoMessage from './pages/glovo/GlovoMessage';
import GlovoNotePrint from './pages/glovo/GlovoNotePrint';
import FacebookTokenHelper from './components/facebook';
import ReceiptPrinter from './pages/receipt/ReceiptPrinter';
import OrderTicket from './pages/receipt/OrderTicket';
import UsersView from './pages/users/usersView';
import ScreenView from './pages/screens/screenView';
import SliderView from './pages/screens/SliderView';
import ScreenOrdersView from './pages/screens/ScreenOrdersView';
import ScreenUserOrdersView from './pages/screens/ScreenUserOrdersView';
import ScreenReportsView from './pages/screens/ScreenReportsView';
import ScreenLogin from './pages/screens/ScreenLogin';
import SlidesShowTable from './pages/views/SlidesShowTable';
import KanbanTaches from './pages/tasks/ManagementTasks';
import InternalOrdersBoard from './pages/internalorders/InternalOrdersBoard';
import Catalog from './pages/views/catalog/catalog';
import ComponentsManager from './pages/ComponentsManager';
import VariablesManager from './pages/VariablesManager';
import StoresView from './pages/stores/StoresView';
import PointageView from './pages/pointage/PointageView';
import ProductCategoriesView from './pages/settings/ProductCategoriesView';
import PlateformsView from './pages/settings/PlateformsView';
import ImageProcessingManager from './pages/ImageProcessingManager';
import WooOrdersView from './pages/WooOrdersView';
import DriverOrdersView from './pages/DriverOrdersView';
import MailPage from './modules/mail/pages/MailPage';
import TicketByAmount from './pages/TicketByAmount';
import InventoryManager from './pages/InventoryManager';
import StockToFillPage from './pages/StockToFill';
import AdminOrdersSummary from './pages/AdminOrdersSummary';
import MessagingInbox from './pages/MessagingInbox';
import AimerPlatformConsole from './pages/settings/AimerPlatformConsole';
import KooulPlatformConsole from './pages/settings/KooulPlatformConsole';
import KooulSyncConsole from './pages/settings/KooulSyncConsole';
import MarjaneMallOrdersSync from './pages/settings/MarjaneMallOrdersSync';
import ProductAddonsView from './pages/products/ProductAddonsView';
import InventoryCalculation from './pages/InventoryCalculation';
import ScreenViewsView from './pages/views/ScreenViewsView';
import PrivateRouteScreen from './components/PrivateRouteScreen';
import GlovoPlatformDashboard from './pages/glovo/GlovoPlatformDashboard';
import GlovoTracking from './pages/glovo/GlovoTracking';
import GlovoSistersDashboard from './pages/glovo/GlovoSistersDashboard';
import TokensView from './pages/settings/TokensView';
import CompaniesView from './pages/settings/CompaniesView';
import SpecialCollections from './pages/SpecialCollections';
import PosPage from './pos/PosPage';
import PosCashSessionsView from './pos/PosCashSessionsView';
import PosDiscountsView from './pos/PosDiscountsView';
import PosReturnsView from './pos/PosReturnsView';
import PaymentMethodsView from './pos/PaymentMethodsView';
import InternalOrderCreate from './pages/InternalOrderCreate';
import QuotesView from './pages/QuotesView';
import WooCategoriesView from './pages/WooCategoriesView';
import WooDeliverySettingsView from './pages/WooDeliverySettingsView';
import RemotePrintersView from './pages/settings/RemotePrintersView';
import ProductSalesStatistics from './pages/ProductSalesStatistics';

const routePermissions = {
  dashboard: ['admin', 'manager'],
  cmiExcel: ['admin', 'manager'],
  addProductSite: ['admin', 'manager', 'accountant'],
  productList: ['admin', 'manager'],
  carrefourSell: ['admin', 'manager', 'accountant', 'carrefour'],
  carrefourOrders: ['admin', 'manager', 'carrefour'],
    tokens: ['admin'],
  carrefourEcommerce: ['admin'],
  storeQuickProduct: ['admin', 'manager'],
  productSalesStatistics: ['admin', 'manager'],
  ordersGlovo: ['admin', 'manager', 'accountant', 'operator', 'driver', 'carrefour'],
  glovoExtended: ['admin', 'manager', 'accountant', 'operator', 'driver', 'user', 'carrefour'],
  glovoNotePrint: [],
  ordersForCarrefour: ['admin', 'manager'],
  ordersSummary: ['admin'],
  quotes: ['admin', 'manager', 'accountant', 'operator', 'user', 'carrefour'],
  stockHouse: ['admin', 'manager', 'accountant'],
  inventory: ['admin', 'manager', 'accountant'],
  tracker: ['admin'],
  barcode: ['admin', 'manager', 'accountant'],
  users: ['admin'],
  stores: ['admin'],
  companies: ['admin'],
  productCategories: ['admin'],
  wooCategories: ['admin', 'manager'],
  wooDeliverySettings: ['admin'],
  plateforms: ['admin'],
  glovoPlateform: ['admin', 'manager'],
  aimerConsole: ['admin'],
  kooulConsole: ['admin'],
  marjaneMall: ['admin', 'manager'],
  variables: ['admin', 'manager'],
  imageProcessing: ['admin', 'manager', 'accountant', 'operator', 'driver', 'user', 'carrefour'],
  pointage: ['admin', 'manager', 'user', 'carrefour', 'accountant'],
  tasks: [],
  internalOrders: [],
  slides: ['admin', 'manager', 'accountant'],
  catalog: ['admin', 'manager', 'accountant'],
  components: ['admin', 'manager'],
  productAddons: ['admin', 'manager'],
  ticketByAmount: ['admin', 'manager', 'carrefour'],
  facebookToken: ['admin'],
  inventoryCalc: ['admin', 'manager', 'operator', 'driver', 'carrefour'],
  screenViews: ['admin'],
  woocommerceOrders: ['admin', 'manager', 'accountant', 'operator', 'driver'],
  specialCollections: ['admin', 'manager'],
  pos: ['admin', 'manager', 'operator', 'driver'],
  paymentMethods: ['admin', 'manager'],
  internalOrderCreate: ['admin', 'manager'],
  remotePrinters: ['admin', 'manager', 'user'],
  messaging: ['admin', 'support'],
};

function App() {
  const qc = useMemo(() => new QueryClient(), []);
  const IndexRoute = () => {
    try {
      const roles = JSON.parse(sessionStorage.getItem('roles') || '[]');
      const isAdminOrManager = Array.isArray(roles) && (roles.includes('admin') || roles.includes('manager'));
      if (Array.isArray(roles) && roles.includes('driver') && !isAdminOrManager) {
        return <Navigate to="/driver/orders" replace />;
      }
    } catch (e) {
      // ignore
    }
    return <PrivateRoute allowedRoles={routePermissions.dashboard}><DashBoard /></PrivateRoute>;
  };
  return (
    <>
      <QueryClientProvider client={qc}>
      <Routes>
      <Route  path="cmiExcel" element={<PrivateRoute allowedRoles={routePermissions.cmiExcel}><CmiAccounting /></PrivateRoute>} />
      <Route path='/addproductsite' element={<PrivateRoute allowedRoles={routePermissions.addProductSite}><AddProductWebsite /></PrivateRoute>} />
      <Route path='/productList' element={<PrivateRoute allowedRoles={routePermissions.productList}><ListofProducts /></PrivateRoute>} />
      <Route path="/dashboard" element={<PrivateRoute allowedRoles={routePermissions.dashboard}><DashBoard /></PrivateRoute>} />
      <Route path="/carrefourSell" element={<PrivateRoute allowedRoles={routePermissions.carrefourSell}><StockUserHandle selectedTag="7" selectedDefaultWarehouse="3" /></PrivateRoute>} />
      <Route path="/carrefourecommerce" element={<PrivateRoute allowedRoles={routePermissions.carrefourEcommerce}><CarrefourEcommerce selectedTag="7" selectedDefaultWarehouse="3" /></PrivateRoute>} />
      <Route path='/storeQuickProduct' element={<PrivateRoute allowedRoles={routePermissions.storeQuickProduct}><StoreQuickProduct /></PrivateRoute>}/>
      <Route path='/product-sales-statistics' element={<PrivateRoute allowedRoles={routePermissions.productSalesStatistics}><ProductSalesStatistics /></PrivateRoute>}/>
      <Route path='/special-collections' element={<PrivateRoute allowedRoles={routePermissions.specialCollections}><SpecialCollections /></PrivateRoute>}/>
      <Route path='/pos' element={<PrivateRoute allowedRoles={routePermissions.pos} fullScreen><PosPage /></PrivateRoute>} />
      <Route path='/pos/cash-sessions' element={<PrivateRoute allowedRoles={routePermissions.pos}><PosCashSessionsView /></PrivateRoute>} />
      <Route path='/pos/discounts' element={<PrivateRoute allowedRoles={routePermissions.pos}><PosDiscountsView /></PrivateRoute>} />
      <Route path='/pos/returns' element={<PrivateRoute allowedRoles={routePermissions.pos}><PosReturnsView /></PrivateRoute>} />
      <Route path='/payment-methods' element={<PrivateRoute allowedRoles={routePermissions.paymentMethods}><PaymentMethodsView /></PrivateRoute>} />
      <Route path='/ordersGlovo' element={<PrivateRoute allowedRoles={routePermissions.ordersGlovo}><OrdersGlovo /></PrivateRoute>}/>
      <Route path='/carrefour/orders/today' element={<PrivateRoute allowedRoles={routePermissions.carrefourOrders}><CarrefourOrdersToday /></PrivateRoute>} />
      <Route path='/carrefour/orders/:date' element={<PrivateRoute allowedRoles={routePermissions.carrefourOrders}><CarrefourOrdersToday /></PrivateRoute>} />
      <Route path='/carrefour/orders/range/:date1/:date2' element={<PrivateRoute allowedRoles={routePermissions.carrefourOrders}><CarrefourOrdersToday /></PrivateRoute>} />
      <Route path='/ordersForCarrefour' element={<PrivateRoute allowedRoles={routePermissions.ordersForCarrefour}><OrdersForCarrefourPage /></PrivateRoute>} />
      <Route path='/orders-summary' element={<PrivateRoute allowedRoles={routePermissions.ordersSummary}><AdminOrdersSummary /></PrivateRoute>} />
      <Route path='/quotes' element={<PrivateRoute allowedRoles={routePermissions.quotes}><QuotesView /></PrivateRoute>} />
      <Route path='/stockHouse' element={<PrivateRoute allowedRoles={routePermissions.stockHouse}><StockByStore /></PrivateRoute>}/>
      <Route path='/inventory' element={<PrivateRoute allowedRoles={routePermissions.inventory}><InventoryManager /></PrivateRoute>}/>
      <Route path='/inventory/stock-to-fill' element={<PrivateRoute allowedRoles={routePermissions.inventory}><StockToFillPage /></PrivateRoute>} />
      <Route path='/inventory-calc' element={<PrivateRoute allowedRoles={routePermissions.inventoryCalc}><InventoryCalculation /></PrivateRoute>}/>
      <Route path='/tracker' element={<PrivateRoute allowedRoles={routePermissions.tracker}><MapComponent /></PrivateRoute>}/>
      <Route path='/barcode' element={<PrivateRoute allowedRoles={routePermissions.barcode}><BarcodePage /></PrivateRoute>}/>
      <Route path='/storeExpress/:id' element={<StoreExpress />} />
      <Route path="/facebook-token" element={<PrivateRoute allowedRoles={routePermissions.facebookToken}><FacebookTokenHelper /></PrivateRoute>} />
      <Route path="/users" element={<PrivateRoute allowedRoles={routePermissions.users}><UsersView /></PrivateRoute>} />
        <Route path="/stores" element={<PrivateRoute allowedRoles={routePermissions.stores}><StoresView /></PrivateRoute>} />
        <Route path="/companies" element={<PrivateRoute allowedRoles={routePermissions.companies}><CompaniesView /></PrivateRoute>} />
        <Route path="/product-categories" element={<PrivateRoute allowedRoles={routePermissions.productCategories}><ProductCategoriesView /></PrivateRoute>} />
        <Route path="/woo-categories" element={<PrivateRoute allowedRoles={routePermissions.wooCategories}><WooCategoriesView /></PrivateRoute>} />
        <Route path="/plateforms" element={<PrivateRoute allowedRoles={routePermissions.plateforms}><PlateformsView /></PrivateRoute>} />
        <Route path="/plateforms/glovo" element={<PrivateRoute allowedRoles={routePermissions.glovoPlateform}><GlovoPlatformDashboard /></PrivateRoute>} />
        <Route path="/plateforms/glovo-sisters" element={<PrivateRoute allowedRoles={routePermissions.glovoPlateform}><GlovoSistersDashboard /></PrivateRoute>} />
        <Route path="/glovo/tracking" element={<PrivateRoute allowedRoles={routePermissions.glovoPlateform}><GlovoTracking /></PrivateRoute>} />
        <Route path="/plateforms/aimer" element={<PrivateRoute allowedRoles={routePermissions.aimerConsole}><AimerPlatformConsole /></PrivateRoute>} />
        <Route path="/plateforms/kooul" element={<PrivateRoute allowedRoles={routePermissions.kooulConsole}><KooulPlatformConsole /></PrivateRoute>} />
        <Route path="/kooul/sync" element={<PrivateRoute allowedRoles={routePermissions.kooulConsole}><KooulSyncConsole /></PrivateRoute>} />
        <Route path="/plateforms/marjanemall" element={<PrivateRoute allowedRoles={routePermissions.marjaneMall}><MarjaneMallOrdersSync /></PrivateRoute>} />
        <Route path="/variables" element={<PrivateRoute allowedRoles={routePermissions.variables}><VariablesManager /></PrivateRoute>} />
        <Route path="/remote-printers" element={<PrivateRoute allowedRoles={routePermissions.remotePrinters}><RemotePrintersView /></PrivateRoute>} />
        <Route path="/image-processing" element={<PrivateRoute allowedRoles={routePermissions.imageProcessing}><ImageProcessingManager /></PrivateRoute>} />
        <Route path="/pointage" element={<PrivateRoute allowedRoles={routePermissions.pointage}><PointageView /></PrivateRoute>} />
          <Route path="/tokens" element={<PrivateRoute allowedRoles={routePermissions.tokens}><TokensView /></PrivateRoute>} />
        <Route path="/woo-orders" element={<PrivateRoute allowedRoles={routePermissions.woocommerceOrders}><WooOrdersView /></PrivateRoute>} />
        <Route path="/woo-delivery-settings" element={<PrivateRoute allowedRoles={routePermissions.wooDeliverySettings}><WooDeliverySettingsView /></PrivateRoute>} />
        <Route path="/driver/orders" element={<PrivateRoute allowedRoles={['driver', 'admin']}><DriverOrdersView /></PrivateRoute>} />
      <Route path="/tasks" element={<PrivateRoute allowedRoles={routePermissions.tasks}><KanbanTaches /></PrivateRoute>} />
      <Route path="/internal-orders" element={<PrivateRoute allowedRoles={routePermissions.internalOrders}><InternalOrdersBoard /></PrivateRoute>} />
      <Route path='/commandes/:id' element={<Navigate to="/screens/orders" replace />} />
      <Route path='/featured' element={<SliderView />} />
      <Route path='/featured/:id' element={<SliderView />} />
      <Route path='/glovonotes' element={<PrivateRoute allowedRoles={routePermissions.glovoExtended}><GlovoNotes /></PrivateRoute>} />
      <Route path='/mail' element={<PrivateRoute allowedRoles={['admin','manager']}><MailPage /></PrivateRoute>} />
      <Route path='/messaging' element={<PrivateRoute allowedRoles={routePermissions.messaging}><MessagingInbox /></PrivateRoute>} />
      <Route path='/glovo-message' element={<PrivateRoute allowedRoles={routePermissions.glovoExtended}><GlovoMessage /></PrivateRoute>} />
      <Route path='/glovo-note-print' element={<PrivateRoute allowedRoles={routePermissions.glovoNotePrint}><GlovoNotePrint /></PrivateRoute>} />
      <Route path='/deliveries' element={<DeliveriesApp />} />
      <Route path='/login' element={<Login />} />
      <Route path='/screens/login' element={<ScreenLogin />} />
      <Route path='/screens/orders' element={<PrivateRouteScreen><ScreenOrdersView /></PrivateRouteScreen>} />
      <Route path='/screens/user-orders' element={<PrivateRouteScreen requiredViews={['user', 'orders']}><ScreenUserOrdersView /></PrivateRouteScreen>} />
      <Route path='/screens/reports' element={<PrivateRouteScreen requiredViews={['report']}><ScreenReportsView /></PrivateRouteScreen>} />
      <Route path='/print-receipt' element={<ReceiptPrinter />} />
      <Route path='/order-ticket' element={<OrderTicket />} />
      <Route path='/slides' element={<PrivateRoute allowedRoles={routePermissions.slides}><SlidesShowTable /></PrivateRoute>} />
      <Route path='/catalog' element={<PrivateRoute allowedRoles={routePermissions.catalog}><Catalog /></PrivateRoute>} />
      <Route path='/components' element={<PrivateRoute allowedRoles={routePermissions.components}><ComponentsManager /></PrivateRoute>} />
      <Route path='/product-addons' element={<PrivateRoute allowedRoles={routePermissions.productAddons}><ProductAddonsView /></PrivateRoute>} />
      <Route path='/internal-order-create' element={<PrivateRoute allowedRoles={routePermissions.internalOrderCreate}><InternalOrderCreate /></PrivateRoute>} />
      <Route path='/ticket-by-amount' element={<PrivateRoute allowedRoles={routePermissions.ticketByAmount}><TicketByAmount /></PrivateRoute>} />
      <Route path='/screen-views' element={<PrivateRoute allowedRoles={routePermissions.screenViews}><ScreenViewsView /></PrivateRoute>} />
      <Route index element={<IndexRoute />} />
    </Routes>
    </QueryClientProvider>

    </>
  );
}

export default App;
